<template>
    <v-card>
        {{ title }}
        {{ nested.level }}
        <v-btn @click="getRandomText">
            Go
        </v-btn>
    </v-card>
</template>
<script>
export default {
    props: {
        initialTitle: {},
        entrypoint: { default: 'JCardEntrypoint' }
    },

    data: () => ({
        response: null,
        title: '',
        nested: {
            level: ''
        },
    }),

    created() {
        this.title = this.initialTitle
        // setTimeout(this.getRandomText, 800)
    },

    methods: {
        getRandomText() {
            // todo refactor JCard, <j-card />,  to:  JmpCard, <jmp-card />
            // todo window.Jumper OR Vue plugin (this.$jmp) ?
            // todo apply convention '{this}Entrypoint'
            // todo Assess the need to pass down `this` .... VuePlugin?? $this.jmp() // vue plugin // Vue.use(jumper)
            // todo implement handling server side extra: `.bff().then()`
            this.$jmp.bff(this, this.entrypoint)
        },
    },
}
</script>
